import { portalApi } from '../../../store/generated/portal/assessments/plans-tasks';

export enum ActionPlanTasksApiTags {
  ActionPlanTasks = 'ActionPlanTasks',
}

const actionPlanTaskApi = portalApi.enhanceEndpoints({
  addTagTypes: [ActionPlanTasksApiTags.ActionPlanTasks],
  endpoints: {
    apiPortalV1AssessmentsPlansTasksList: {
      providesTags: [ActionPlanTasksApiTags.ActionPlanTasks],
    },
    apiPortalV1AssessmentsPlansTasksCreate: {
      invalidatesTags: [ActionPlanTasksApiTags.ActionPlanTasks],
    },
    apiPortalV1AssessmentsPlansTasksRetrieve: {
      providesTags: (result, error, arg) => [
        { type: ActionPlanTasksApiTags.ActionPlanTasks, id: arg.id },
      ],
    },
    apiPortalV1AssessmentsPlansTasksUpdate: {
      invalidatesTags: (result, error, arg) => [
        { type: ActionPlanTasksApiTags.ActionPlanTasks, id: arg.id },
        ActionPlanTasksApiTags.ActionPlanTasks,
      ],
    },
    apiPortalV1AssessmentsPlansTasksPartialUpdate: {
      invalidatesTags: (result, error, arg) => [
        { type: ActionPlanTasksApiTags.ActionPlanTasks, id: arg.id },
        ActionPlanTasksApiTags.ActionPlanTasks,
      ],
    },
    apiPortalV1AssessmentsPlansTasksDestroy: {
      invalidatesTags: [ActionPlanTasksApiTags.ActionPlanTasks],
    }

  }
});

export { actionPlanTaskApi };
